import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { IntlProvider } from "react-intl";
import { useAppConfig } from "@ct-react/core";
import { defaultLocale, useLocaleContext } from "@ct-react/locale";
import { getIntlMessages } from "./i18n";
import { BookmarksProvider } from "./contexts/bookmarks";
import { SearchProvider } from "./contexts/search";
import Header from "./components/layout/header";
import SearchBarIntoLayout from "./components/layout/search-bar-wrapper";
import Footer from "./components/layout/footer";
import "./scss/global.scss";

const App = () => {

  const { id } = useAppConfig();
  const { locale } = useLocaleContext();
  const location = useLocation();

  useEffect(() => {
    document.documentElement.lang = locale.code;
  }, [ locale ]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [ location.pathname ]);

  return (
    <IntlProvider locale={locale.code}
                  defaultLocale={defaultLocale.code}
                  messages={getIntlMessages(locale)}>
      <SearchProvider>
        <BookmarksProvider>
          <meta property="og:locale" content={locale.code} />
          <meta property="og:type" content="website" />
          <meta property="og_site_name" content={id} />
          <Header />
          <SearchBarIntoLayout />
          <div className="main-wrap">
            <Outlet />
          </div>
          <Footer />
        </BookmarksProvider>
      </SearchProvider>
    </IntlProvider>);

}

export default App;
